import personalDocumentsDictionary from '@entities/personal-documents/i18n/ru/personal-documents.dic.json';

export const personalDocuments = {
  PERSONAL_DOCUMENTS: personalDocumentsDictionary,
};

export const personalDocumentsNamespaces = ['PERSONAL_DOCUMENTS'];
